"use client";

import React, { useState } from "react";
import Link from "next/link";
import { usePathname } from "next/navigation";
import "./ActivitiesSection.css";

export default function ActivitiesSection() {
  const pathname = usePathname();
  const pathSegments = pathname.split("/");
  const locale = ["en", "th", "zh"].includes(pathSegments[1])
    ? pathSegments[1]
    : "en";

  const [keyword, setKeyword] = useState("");
  const [typeFilter, setTypeFilter] = useState("All");
  const [statusFilter, setStatusFilter] = useState("All");
  const [sortOption, setSortOption] = useState("Date");

  const activities = [
    {
      title: "Trading skills competition",
      desc: "Showcase your skills",
      date: "April 8, 2025",
      image: "/trophy-contest.png",
      link: "contest",
      tags: ["Contest", "Upcoming", "Online", "Free"],
      button: "Join now",
    },
    {
      title: "Industry networking",
      desc: "Engage in trading discussions",
      date: "April 7, 2025",
      image: "/event.png",
      link: "salon",
      tags: ["Salon Exchange", "Upcoming"],
      button: "Join now",
    },
    {
      title: "Trading & investment expo",
      desc: "Explore the latest market trends",
      date: "March 25, 2025",
      image: "/evnet-over.png",
      link: "exhibition",
      tags: ["Exhibition"],
      button: "Read more",
      buttonClass: "green",
    },
    {
      title: "Meet our sponsors",
      desc: "For future-events",
      date: "",
      image: "/sponsor-card.png",
      link: "sponsor",
      tags: ["Sponsor Center"],
      sponsorNames: ["Verck", "SALO", "COSX"],
      button: "Become a Sponsor",
      buttonClass: "teal",
    },
  ];

  const tagColor = (tag) => {
    const colors = {
      Contest: "purple",
      Upcoming: "green",
      Online: "dark",
      Free: "light",
      "Salon Exchange": "orange",
      Exhibition: "purple",
      "Sponsor Center": "grey",
    };
    return colors[tag] || "dark";
  };

  let filteredActivities = activities.filter((a) =>
    a.title.toLowerCase().includes(keyword.toLowerCase())
  );

  if (typeFilter !== "All") {
    filteredActivities = filteredActivities.filter((a) =>
      a.tags.some((tag) => tag.toLowerCase().includes(typeFilter.toLowerCase()))
    );
  }

  if (statusFilter !== "All") {
    filteredActivities = filteredActivities.filter((a) =>
      a.tags.includes(statusFilter)
    );
  }

  if (sortOption === "Name") {
    filteredActivities.sort((a, b) => a.title.localeCompare(b.title));
  } else if (sortOption === "Date") {
    filteredActivities.sort((a, b) => new Date(b.date) - new Date(a.date));
  }

  return (
    <div className="activities-container">
      <h1 className="activities-title">Activities</h1>

      <div className="activities-banner">
        <div>
          <h2>Activities</h2>
          <p>Global trading conference</p>
        </div>
        <button className="start-button hidden">Learn more</button>
      </div>

      <div className="activity-filters">
        <select
          className="activity-dropdown"
          value={typeFilter}
          onChange={(e) => setTypeFilter(e.target.value)}
        >
          <option value="All">All</option>
          <option value="Salon">Salon</option>
          <option value="Contest">Contest</option>
          <option value="Exhibition">Exhibition</option>
          <option value="Sponsor">Sponsor</option>
        </select>
        <select
          className="activity-dropdown"
          value={statusFilter}
          onChange={(e) => setStatusFilter(e.target.value)}
        >
          <option value="All">All</option>
          <option value="Upcoming">Upcoming</option>
          <option value="Past">Past</option>
        </select>
        <input
          type="text"
          className="activity-search"
          placeholder="Filter keyword"
          value={keyword}
          onChange={(e) => setKeyword(e.target.value)}
        />
        <select
          className="activity-dropdown"
          value={sortOption}
          onChange={(e) => setSortOption(e.target.value)}
        >
          <option value="Date">Sort by: Date</option>
          <option value="Name">Sort by: Name</option>
        </select>
      </div>

      {filteredActivities.length === 0 ? (
        <p style={{ textAlign: "center", marginTop: "40px" }}>
          No activities found.
        </p>
      ) : (
        <div className="activities-grid two-column">
          {filteredActivities.map((a, idx) => (
            <Link
              key={idx}
              href={`/${locale}/activities/${a.link}`}
              className="activity-card"
            >
              <div className="card-labels">
                {a.tags.map((tag, i) => (
                  <span key={i} className={`label ${tagColor(tag)}`}>
                    {tag}
                  </span>
                ))}
              </div>
              <img src={a.image} alt={a.link} className="card-image" />
              <h3>{a.title}</h3>
              <p>{a.desc}</p>
              {a.date && <p className="card-date">{a.date}</p>}
              {a.sponsorNames && (
                <p className="sponsor-names">
                  {a.sponsorNames
                    .map((s, i) => <strong key={i}>{s}</strong>)
                    .reduce((prev, curr) => [prev, ", ", curr])}
                </p>
              )}
              <button className={`card-button ${a.buttonClass || ""}`.trim()}>
                {a.button}
              </button>
            </Link>
          ))}
        </div>
      )}
    </div>
  );
}
